import { useCompanyConfigurations } from "hooks/useCompanyConfigurations";

const DATA_KEYS = {
  AMPLEND: "amplend",
  PHOENIX: "phoenix",
} as const;

type Context = {
  isAmplend: boolean;
  isPhoenix: boolean;
};

export function useCustomizations(): Context {
  const { data: configurations, isLoading } = useCompanyConfigurations();

  if (!configurations || isLoading) {
    return {
      isAmplend: false,
      isPhoenix: false,
    };
  }

  return {
    isAmplend: configurations?.data_key === DATA_KEYS.AMPLEND,
    isPhoenix: configurations?.data_key === DATA_KEYS.PHOENIX,
  };
}
